<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input
        v-model="params.id"
        placeholder="请输入女优ID"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-input
        v-model="params.name"
        placeholder="请输入女优名称"
        clearable
        size="small"
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请选择状态"
        clearable
        size="small"
        v-model="params.status"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in statuses"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择订阅状态"
        clearable
        size="small"
        v-model="params.subscriptionStatus"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in SubscriptionStatuss"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择类型"
        clearable
        size="small"
        v-model="params.type"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in types"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-select
        placeholder="请选择是否推荐"
        clearable
        size="small"
        v-model="params.isRecommend"
      >
        <el-option
          :label="item.label"
          :value="item.value"
          v-for="item in isRecommends"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getList('status')"
        style="margin-right: 20px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="addAndEdit('add')"
        style="margin-right: 20px"
        >新增</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      height="600"
    >
      <el-table-column prop="id" label="ID" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="女优名称"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="chineseName"
        label="中文名称"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.chineseName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="pinyin"
        label="中文拼音"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.pinyin || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="alias" label="别名" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.alias || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="englishName"
        label="英文名称"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.englishName || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="portrait" label="头像" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.portrait">暂无头像</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.portrait })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.portrait"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="coverThumb"
        label="背景小图"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.coverThumb">暂无背景小图</span>
          <div
            v-else
            class="picturePreview"
            @click="
              handlePictureCardPreview({ url: imgUrl + scope.row.coverThumb })
            "
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.coverThumb"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="cover" label="背景大图" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="!scope.row.cover">暂无背景大图</span>
          <div
            v-else
            class="picturePreview"
            @click="handlePictureCardPreview({ url: imgUrl + scope.row.cover })"
          >
            <el-image
              style="width: 80px; height: 80px"
              :src="imgUrl + scope.row.cover"
              fit="fill"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="seriesCover"
        label="女优套图"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.seriesCover">暂无套图</span>
          <div
            v-else
            class="picturePreview"
            @click="previewPicture(scope.row.seriesCover || [], scope.row.id)"
          >
            <el-image
              style="width: 50px; height: 50px"
              :src="imgUrl + item"
              fit="fill"
              v-for="(item, i) in scope.row.seriesCover"
              :key="i"
            ></el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="summary" label="简介" align="center" width="120">
        <template slot-scope="scope">
          <el-popover placement="top-start" width="400px" trigger="hover">
            <span>{{ scope.row.summary }}</span>
            <span slot="reference">{{ scope.row.summary ? scope.row.summary.substring(0,6)+'......' : "" }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="region"
        label="地区/国家"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.region || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="office" label="事务所" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.office || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="birthday" label="生日" align="center" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row | getBirthday }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="videoCount"
        label="影片数"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.videoCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="picsCount"
        label="图集数"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.picsCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="collectCount"
        label="粉丝数"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.collectCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="commentCount"
        label="评论数"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.commentCount || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="score" label="女优评分" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.score || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="height"
        label="女优身高(cm)"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.height || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="bloodType" label="血型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.bloodType || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cupSize" label="罩杯" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.cupSize || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="threeDimensions"
        label="女优三围(cm)"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.threeDimensions || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.type == 1">女优</el-tag>
          <el-tag v-else-if="scope.row.type == 2">网黄</el-tag>
          <el-tag type="warning" v-else-if="scope.row.type == 3">主播</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1">上架</el-tag>
          <el-tag v-else>下架</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="subscriptionStatus" label="订阅状态" align="center" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.subscriptionStatus == 1">开启</el-tag>
          <el-tag v-else>关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="订阅价格" align="center">
      </el-table-column> -->
      <el-table-column prop="duration" label="奖励时长" align="center">
      </el-table-column>
      <el-table-column
        prop="debutTime"
        label="出道日期"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.debutTime | changeMd }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sortCode" label="排序" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.sortCode || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAct"
        label="操作人"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAct || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="200"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="success"
            icon="el-icon-edit"
            @click="addAndEdit(scope.row)"
            >编辑</el-button>
          <!-- <el-button v-if="scope.row.type === 2" type="warning" size="mini" @click="batchUpdPrice(scope.row)">修改所有帖子价格</el-button> -->
          <!-- <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="del(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 30, 50, 100]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1200px"
      @before-close="handleClose"
      @close="handleClose"
    >
      <el-form :model="form" label-width="100px" :rules="rules" ref="form">
        <div class="itemBox">
          <el-form-item
            size="small"
            label="女优名称:"
            prop="name"
            style="width: 480px"
          >
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item
            label="中文名称:"
            size="small"
            prop="chineseName"
            style="width: 480px"
          >
            <el-input v-model="form.chineseName"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="中文拼音:"
            prop="pinyin"
            style="width: 480px"
          >
            <el-input v-model="form.pinyin"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            label="英文名称:"
            size="small"
            prop="englishName"
            style="width: 480px"
          >
            <el-input v-model="form.englishName"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="别名:"
            prop="alias"
            style="width: 480px"
          >
            <el-input v-model="form.alias"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="类型:"
            prop="type"
            style="width: 480px"
          >
            <el-select v-model="form.type" placeholder="请选择类型">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in types"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="女优身高(cm):"
            prop="height"
            style="width: 480px"
          >
            <el-select v-model="form.height" placeholder="请选择女优身高">
              <el-option
                :label="item.text"
                :value="item.value"
                v-for="item in heights"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            size="small"
            label="女优体重(kg):"
            prop="weight"
            style="width: 480px"
          >
            <el-input v-model="form.weight"></el-input>
          </el-form-item>
          <!-- <el-form-item
            size="small"
            label="女优年龄:"
            prop="age"
            style="width: 480px"
          >
            <el-select v-model="form.age" placeholder="请选择女优年龄">
              <el-option
                :label="item.text"
                :value="item.value"
                v-for="item in ages"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="罩杯级别:"
            prop="cupSize"
            style="width: 480px"
          >
            <el-select v-model="form.cupSize" placeholder="请选择罩杯级别">
              <el-option
                :label="item.text"
                :value="item.value"
                v-for="item in cupSizes"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            size="small"
            label="女优三围(cm):"
            prop="threeDimensions"
            style="width: 480px"
          >
            <el-input v-model="form.threeDimensions"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="女优血型:"
            prop="bloodType"
            style="width: 480px"
          >
            <el-select v-model="form.bloodType" placeholder="请选择女优血型">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in bloodTypes"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="生日:"
            prop="birthday"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.birthday"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            size="small"
            label="出道日期:"
            prop="debutTime"
            style="width: 480px"
          >
            <el-date-picker
              type="date"
              v-model="form.debutTime"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            size="small"
            label="地区/国家:"
            prop="region"
            style="width: 480px"
          >
            <el-select v-model="form.region" placeholder="请选择地区/国家">
              <el-option
                :label="item.text"
                :value="item.value"
                v-for="item in regions"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="女优状态:"
            prop="status"
            style="width: 480px"
          >
            <el-select v-model="form.status" placeholder="请选择女优状态">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in statuses"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            size="small"
            label="女优评分:"
            prop="score"
            style="width: 480px"
          >
            <el-input v-model="form.score"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="排序:"
            prop="sortCode"
            style="width: 480px"
          >
            <el-input v-model.number="form.sortCode"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <!-- <el-form-item
            size="small"
            label="订阅状态:"
            prop="subscriptionStatus"
            style="width: 480px"
          >
            <el-select v-model.number="form.subscriptionStatus" placeholder="请选择订阅状态">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in SubscriptionStatuss"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            size="small"
            label="订阅价格:"
            prop="price"
            style="width: 480px">
            <el-input v-model.number="form.price"></el-input>
          </el-form-item> -->
          <el-form-item
            size="small"
            label="奖励时长:"
            prop="duration"
            style="width: 480px"
          >
            <el-input v-model.number="form.duration"></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="事务所:"
            prop="office"
            style="width: 385px"
          >
            <el-input v-model="form.office"></el-input>
          </el-form-item>
          <el-form-item
            size="small"
            label="是否推荐:"
            prop="isRecommend"
            style="width: 385px"
          >
            <el-select v-model="form.isRecommend" placeholder="请选择是否推荐">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in isRecommends"
                :key="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            size="small"
            label="简介:"
            prop="summary"
            style="width: 775px"
          >
            <el-input
              type="textarea"
              :rows="4"
              v-model="form.summary"
            ></el-input>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item size="small" label="特点:" prop="feature">
            <el-checkbox-group v-model="form.feature">
              <el-checkbox
                v-for="feature in features"
                :label="feature.value"
                :key="feature.value"
                >{{ feature.text }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="itemBox"></div>
        <div class="itemBox">
          <el-form-item
            size="small"
            label="头像:"
            prop="portrait"
            style="width: 480px"
          >
            <base-upload
              :cover="form.portrait"
              :action="uploadUrl"
              @successCallback="uploadPortrait"
              :width="'120px'"
              :height="'120px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
          <el-form-item
            size="small"
            label="背景小图:"
            prop="coverThumb"
            style="width: 480px"
          >
            <base-upload
              :cover="form.coverThumb"
              :action="uploadUrl"
              @successCallback="uploadCoverThumb"
              :width="'180px'"
              :height="'90px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
          <el-form-item
            size="small"
            label="背景大图:"
            prop="cover"
            style="width: 480px"
          >
            <base-upload
              :cover="form.cover"
              :action="uploadUrl"
              @successCallback="uploadCover"
              :width="'240px'"
              :height="'120px'"
              :hide="true"
            ></base-upload>
          </el-form-item>
        </div>
        <div class="itemBox">
          <el-form-item size="small" label="女优套图:" prop="seriesCover">
            <el-upload
              :action="uploadUrl"
              list-type="picture-card"
              name="upload"
              :on-success="successCallback"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :headers="header"
              :file-list="fileList"
              accept="image/jpeg, image/png, image/jpg, image/gif, image/webp"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblePreview">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
  </div>
</template>
<script>
import API from "@/api";
import { uniteDate } from "@/utils/validator.js";
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import PreviewPicture from "./components/previewPicture";
import { prefixZero } from "../../../utils/filter";

export default {
  components: {
    PreviewPicture,
  },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 封面上传地址
      uploadUrl: baseConfig.baseServerUrl + "/vid/uploadStatic",
      header: {
        Authorization: local.get("userInfo").token,
      },
      dialogImageUrl: undefined, // 放大图地址
      dialogVisiblePreview: false, // 放大图
      imgUrl: baseConfig.imgUrl,
      fileList: [], // 用于编辑图片回显
      // 列表数据
      tableData: [],
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10,
        id: undefined, // ID
        name: undefined, // 名称
        status: undefined, // 状态
        subscriptionStatus: undefined, //订阅状态
        isRecommend: undefined, // 是否推荐
        type: undefined, // 类型
      },
      rules: {
        name: [{ required: true, message: "请输入女优名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入女优订阅价格", trigger: "blur" }],
        cupSize: [
          { required: true, message: "请选择罩杯级别", trigger: "blur" },
        ],
        status: [
          { required: true, message: "请选择女优状态", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择女优类型", trigger: "blur" }],
      },
      types: [
        {
          label: "女优",
          value: 1,
        },
        {
          label: "网黄",
          value: 2,
        },
        {
          label: "主播",
          value: 3,
        },
        {
          label: "声优",
          value: 4,
        },
      ],
      statuses: [
        {
          label: "上架",
          value: 1,
        },
        {
          label: "下架",
          value: 2,
        },
      ],
      SubscriptionStatuss: [
        {
          label: "开启",
          value: 1,
        },
        {
          label: "关闭",
          value: 2,
        },
      ],
      bloodTypes: [
        {
          label: "A型",
          value: "A型",
        },
        {
          label: "B型",
          value: "B型",
        },
        {
          label: "AB型",
          value: "AB型",
        },
        {
          label: "O型",
          value: "O型",
        },
        {
          label: "RH型",
          value: "RH型",
        },
      ],
      isRecommends: [
        {
          label: "是",
          value: true,
        },
        {
          label: "否",
          value: false,
        },
      ],
      heights: [],
      cupSizes: [],
      ages: [],
      features: [],
      regions: [],
      dialogTitle: "",
      dialogVisible: false,
      initialName: undefined, // 初始女优名称(用于校验是否修改过值)
      form: {
        id: undefined,
        name: undefined, // 女优名称
        chineseName: undefined, // 中文名称
        pinyin: undefined, // 中文拼音
        alias: undefined, // 别名
        englishName: undefined, // 英文名称
        cover: undefined, // 背景大图
        coverThumb: undefined, // 背景小图
        seriesCover: undefined, // 女优套图
        portrait: undefined, // 头像
        summary: undefined, // 简介
        region: undefined, // 地区/国家
        birthday: undefined, // 生日
        score: undefined, // 女优评分
        height: undefined, // 女优身高
        age: undefined, // 女优年龄
        weight: undefined, // 女优体重
        bloodType: "A型", // 女优血型
        cupSize: undefined, // 罩杯级别
        threeDimensions: undefined, // 女优三围
        type: 1, // 类型 1、女优 2、网黄 3、主播
        status: 1, // 女优状态 1、上架 2、下架
        subscriptionStatus: 1, // 订阅状态 1、开启 2、关闭
        price: undefined, // 订阅价格
        duration: undefined, // 奖励时长
        debutTime: undefined, // 出道日期
        sortCode: 0, // 排序
        feature: [], // 特点
        office: undefined, // 事务所
        isRecommend: false, // 是否推荐
      },
    };
  },
  created() {
    this.getOptions();
    this.getList();
  },
  methods: {
    batchUpdPrice(row) {
      this.$prompt("请输入修改后的价格", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]\d*$/,
        inputErrorMessage: "请输入正整数",
      })
        .then(async ({ value }) => {
          let req = {
            id: row.id,
            price: Number(value),
          };
          API.updManyActressVidPrice(req)
            .then((res) => {
              if (res && res.code == 200) {
                this.$message.success("修改成功");
              } else {
                this.$message.error("修改失败" + (res.msg || res.tip));
              }
            })
            .catch((err) => {
              this.$message.error("修改异常" + err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    getOptions() {
      API.getActressOptions().then((res) => {
        if (res.code === 200 && res.data) {
          this.heights = res.data.height.values || [];
          this.cupSizes = res.data.cupSize.values || [];
          this.ages = res.data.age.values || [];
          this.features = res.data.feature.values || [];
          this.regions = res.data.region.values || [];
        }
      });
    },
    // 背景大图上传成功
    uploadCover(res) {
      this.form.cover = res.data.coverImg;
    },
    // 背景小图上传成功
    uploadCoverThumb(res) {
      this.form.coverThumb = res.data.coverImg;
    },
    // 头像上传成功
    uploadPortrait(res) {
      this.form.portrait = res.data.coverImg;
    },
    // 女优套图上传成功
    successCallback(res) {
      if (!this.form.seriesCover) {
        this.form.seriesCover = [];
      }
      this.form.seriesCover.push(res.data.coverImg);
    },
    handleRemove(file) {
      this.form.seriesCover = this.form.seriesCover.filter((item) => {
        if (file.response) {
          if (item != file.response.data.coverImg) {
            return item;
          }
        } else {
          if (item != file.name) {
            return item;
          }
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblePreview = true;
    },
    // 图集预览
    previewPicture(pictureArr, id, tags) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id, tags);
    },
    getList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getActressList(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增女优
    addAndEdit(param) {
      if (param === "add") {
        this.dialogTitle = "新增";
      } else {
        this.dialogTitle = "编辑";
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.name = param.name;
        this.initialName = JSON.parse(JSON.stringify(param.name));
        this.form.chineseName = param.chineseName;
        this.form.pinyin = param.pinyin;
        this.form.alias = param.alias;
        this.form.englishName = param.englishName;
        this.form.cover = param.cover;
        this.form.coverThumb = param.coverThumb;
        this.form.portrait = param.portrait;
        this.form.summary = param.summary;
        this.form.region = param.region;
        this.form.office = param.office;
        this.form.birthday = param.birthday;
        this.form.score = param.score;
        this.form.height = param.height;
        this.form.age = param.age;
        this.form.weight = param.weight;
        this.form.bloodType = param.bloodType;
        this.form.cupSize = param.cupSize;
        this.form.threeDimensions = param.threeDimensions;
        this.form.type = param.type;
        this.form.status = param.status;
        this.form.price = param.price;
        this.form.subscriptionStatus = param.subscriptionStatus;
        this.form.duration = param.duration;
        this.form.debutTime = param.debutTime;
        this.form.sortCode = param.sortCode;
        this.form.feature = param.feature || [];
        this.form.isRecommend = param.isRecommend;
        this.form.seriesCover = param.seriesCover || [];
        this.fileList = this.form.seriesCover.map((item) => {
          return {
            name: item,
            url: this.imgUrl + item,
          };
        });
      }
      this.dialogVisible = true; // 打开新增、编辑对话框
    },
    // 新增、修改提交
    onSubmit() {
      if (this.dialogTitle === "新增") {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          API.addActress(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "新增成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "新增失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.initialName == this.form.name) this.form.name = undefined;
          API.updateActress(this.form).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "编辑成功",
              });
              this.handleClose();
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "编辑失败",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    del(param) {
      this.$confirm(
        `确认是否删除<span style='color:blue'>${param.name}</span>女优, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let delData = {
            id: param.id,
          };
          API.delActress(delData).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "success",
                message: "删除失败!",
              });
            }
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.id = undefined;
      this.form.name = undefined;
      this.initialName = undefined;
      this.form.chineseName = undefined;
      this.form.pinyin = undefined;
      this.form.alias = undefined;
      this.form.englishName = undefined;
      this.form.cover = undefined;
      this.form.coverThumb = undefined;
      this.form.seriesCover = undefined;
      this.form.portrait = undefined;
      this.form.summary = undefined;
      this.form.region = undefined;
      this.form.office = undefined;
      this.form.birthday = undefined;
      this.form.score = undefined;
      this.form.height = undefined;
      this.form.age = undefined;
      this.form.weight = undefined;
      this.form.bloodType = "A型";
      this.form.cupSize = undefined;
      this.form.threeDimensions = undefined;
      this.form.type = 1;
      this.form.status = 1;
      this.form.subscriptionStatus = 1;
      this.form.price = undefined;
      this.form.duration = undefined;
      this.form.debutTime = undefined;
      this.form.isRecommend = false;
      this.form.sortCode = 0;
      this.form.feature = [];
      this.fileList = [];
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
  },
  filters: {
    getBirthday(item) {
      if (!item.birthYear) return '未知'
      return `${item.birthYear}.${prefixZero(item.birthMonth)}.${prefixZero(item.birthDate)}`
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  position: relative;
  left: 50%;
  -webkit-transform: translate(-50%);
  transform: translate(-50%);
}
/deep/ .el-form-item__content {
  display: flex;
}
/deep/ .el-select {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
  height: 120px;
}
/deep/ .el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 130px;
}
.itemBox {
  display: flex;
  // justify-content: space-between;
}
</style>
